import React from 'react';
import { BLOG_COPY, formatDate, listPosts, postPath } from '@app/lib/blog';
import { COPY } from '@app/lib/content';
import { pagePath } from '@app/lib/site';
import { useLang } from '@app/lib/useLang';
import { PageHero } from '@widgets';
import pageStyles from '../pageStyles.module.css';
import styles from './style.module.css';

const BlogIndexPage: React.FC = () => {
  const lang = useLang();
  const b = BLOG_COPY[lang];
  const posts = listPosts(lang);

  return (
    <main>
      <PageHero image="/img/hero-1920.jpg" title={b.h1} lead={b.lead} />
      <div className={pageStyles.wrapper}>
        <nav className={pageStyles.breadcrumbs} aria-label="Breadcrumb">
          <a href={pagePath('home', lang)}>{COPY[lang].ui.home}</a> <span aria-hidden>›</span> <span>{b.nav}</span>
        </nav>
        <ul className={styles.cards}>
          {posts.map((p) => (
            <li key={p.slug} className={styles.card}>
              <a href={postPath(p.slug, lang)} className={styles.cardLink}>
                <img src={p.hero} alt={p.heroAlt} loading="lazy" decoding="async" className={styles.cardImage} />
                <div className={styles.cardBody}>
                  <h2 className={styles.cardTitle}>{p.h1}</h2>
                  <p className={styles.cardText}>{p.description}</p>
                  <span className={styles.cardMore}>{b.readMore} →</span>
                </div>
              </a>
              <time dateTime={p.date} className={styles.cardDate}>
                {formatDate(p.date, lang)}
              </time>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
};

export default BlogIndexPage;
